<template>
  <div id="app" :class="$route.meta.ifHomePage? 'bacKK' : 'bac'">
    <router-view/>
  </div>
</template>
<script>
  // @ is an alias to /src
  export default {
    name: "App",
    data() {
      return {

      }
    },
    created () {
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store") ) {
        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))));
        sessionStorage.removeItem('store');
        // this.$router.replace('/')
      }

      //在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload",()=>{
        sessionStorage.setItem("store",JSON.stringify(this.$store.state))
      })
      if (window.localStorage.getItem('access_token')) {
        this.$store.commit('setToken',window.localStorage.getItem('access_token'))
      }
    },
  };
</script>
<style lang="scss">
$font-color1: #24292e;
$font-color2: #303133;
$font-color3: #4c4f56;
html, body {
  height: 100%;
  margin: 0;
  // overflow: hidden;
}
ul {
  padding: 0;
  margin: 0;
  // list-style: none;
  li {
    padding: 6px;
  }
}
body {
  // font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  // font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  line-height: 1.5;
  color: $font-color1;
  font-size: 16px;
  display: flex;
  flex-direction: column;
}
.bacKK {
  // background: linear-gradient(0deg, #ACCFF3, #F2F5F8, #68B6F9);
}
.bac {
  background: #f2f5f8;
  // background: url(/public/body-bg.png) repeat 0 0;
}
#app {
  min-height: 100%;
  flex: 1 0 auto;

  // .el-card {
  //   border: 1px solid #ddd;
  // }
  // card 的 title 样式
  .el-card__header {
    font-size: 16px;
    background-color: #ecf5ff;
    background-color: #f5f5f5;
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#FAFAFA), color-stop(100%,#E9E9E9));
    // background: #295482;  //#E9E9E9
    // color: #fff;
    // border-bottom: 1px solid #ddd;
    padding: 10px 15px;
    font-weight: 800;
    color: #555;
    // border-top-left-radius: 4px;
    // border-top-right-radius: 4px;
  }
  .el-card__body {
    padding: 0px;
  }
  // 表格中 thead 背景色
  .el-table thead {
    // color: #24292e;
    color: $font-color3;
    th {
      background: #f5f7fa;
      padding: 5px 0;
    }
  }
  // .el-table td, .el-table th {
  //   padding: 3px 0;
  // }
  .el-table .cell, .el-table th div {
    padding-right: 6px;
    word-break: keep-all;
    // white-space: normal !important;
    // word-break: break-all;
  }
  // 表格中文字居中
  .el-table .cell, .el-table th div, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
    // padding-left: 6px;
    // text-align: center;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
  // 面包屑
  .el-breadcrumb {
    // background-color: #f5f5f5;
    background-color: #f2f2f2;
    border-radius: 4px;
    padding: 8px 15px;
    // background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #FAFAFA), color-stop(100%, #E9E9E9));
    // border: 1px solid #ddd;
  }
}
a {
  text-decoration: none;
}
h3 {
  margin: 0
}
.clearfix:after {
  display: block;
  content: '';
  clear: both;
}
// .el-popover {
//   background: #327CB9!important;
// }
// .el-popper .popper__arrow{
//   border-top-color: #327CB9!important;
// }
// .el-popper .popper__arrow:after{
//   border-top-color: #327CB9!important;
// }

.tootipbox {
  // display: flex;
  // justify-content: center;
  .tootipboxle {
    // color: #FEE32C;
    font-weight: 600;
    text-align: right;
    vertical-align: middle;
    display: table-cell;
    .Robust {
      color: #FEE32C;
    }
    .Efficient {
      color: #C8F588;
    }
    .Accurate {
      color: #1EECF4;
    }
    .Large-scale {
      color: #C5A4FB;
    }
  }
  .tootipboxri {
    background: rgba(26, 72, 120, 0.05);
    border: 1px solid rgba(115, 183, 241, 0.05);
    color: #ffffff;
    padding: 5px;
    ul {
      li {
        // float: left;
        padding: 0;
        margin-left: 50px;
        text-indent: -20px;
      }
    }
  }
}
.el-dropdown {
  font-size: 18px;
}

.el-collapse-item__content {
  font-size: 16px;
}
.el-table__body tr.current-row>td.el-table__cell, .el-table__body tr.selection-row>td.el-table__cell {
  background-color: #cae1fd;
}
</style>
